import { ApiExec, ApiExecPublic } from '@utils/ApiExec';
import { encryptVars, DEBUG } from '@utils/global';

class UserService {
  /**
   * *OBLIGATORIO* @param page Número de página actual
   * *OBLIGATORIO* @param pageSize Tamaño del bloque de respuesta
   * @returns Una listado de elementos de tamaño pageSize
   */
  getUsers = (params) => {
    return ApiExec(params, 'users/get', 'POST')
      .then((res) => res)
      .then((res) => res)
      .catch((e) => e);
  };

  getUsersInfo = (params) => ApiExec(params, 'users/get-users', 'POST');

  getUser = (params) => {
    return ApiExec(params, '/support/get-users', 'POST')
      .then((res) => res)
      .then((res) => res)
      .catch((e) => e);
  };

  getDevices = (Device) => {
    const device = DEBUG ? Device : encryptVars(Device);
    return ApiExec({}, `users/get-devices/${device}`, 'GET')
      .then((res) => res)
      .then((res) => res)
      .catch((error) => error);
  };

  confirmarCodigo = (params) => {
    return ApiExecPublic(params, 'app/users/code-validate', 'POST')
      .then((res) => res)
      .then((res) => res)
      .catch((e) => e);
  };

  setUser = (params) => {
    return ApiExec(params, `users/create`, 'POST')
      .then((res) => res)
      .then((res) => res)
      .catch((e) => e);
  };

  updateUser = (params) => {
    return ApiExec(params, `users/update`, 'PUT')
      .then((res) => res)
      .then((res) => res)
      .catch((e) => e);
  };

  updateProfile = (params) => {
    return ApiExec(params, 'users/update-user-profile', 'PUT')
      .then((res) => res)
      .then((res) => res)
      .catch((e) => e);
  };

  updatePassword = (params) => {
    return ApiExec(params, `users/update-password`, 'PUT')
      .then((res) => res)
      .then((res) => res)
      .catch((e) => e);
  };

  updatePIN = (params) => {
    return ApiExec(params, `users/update-pin`, 'PUT')
      .then((res) => res)
      .then((res) => res)
      .catch((e) => e);
  };

  updateStatus = (params) => {
    return ApiExec(params, `users/update-status`, 'PUT')
      .then((res) => res)
      .then((res) => res)
      .catch((e) => e);
  };

  updatePhoneNumber = (params) => {
    return ApiExec(params, 'api')
      .then((res) => res)
      .then((res) => res)
      .catch((e) => e);
  };

  /**
   * *OBLIGATORIO* @param page Número de página actual
   * *OBLIGATORIO* @param pageSize Tamaño del bloque de respuesta
   * *OBLIGATORIO* @param idUsuario id del usuario
   * @returns Una listado de elementos de tamaño pageSize
   */
  getAccessLogs = (params) => {
    return ApiExec(params, `users/get-access`, 'POST')
      .then((res) => res)
      .then((res) => res)
      .catch((e) => e);
  };

  getMenus = (params) => {
    return ApiExec(params, `users/get-menus`, 'POST')
      .then((res) => res)
      .then((res) => res)
      .catch((e) => e);
  };

  /**
   * @property {Function} changeAccess - Función para actualizar los privilegios de un menú
   * @param {Object} params - Parámetros para el llamado de la api
   * @param {string} token - Token de acceso para el llamado de la api
   * @returns {Object}
   */
  changeAccess = (params) => {
    /**
     * @typedef {Object} params
     * @property {number} id - id del menú a modificar
     * @property {string} colum - Opción de ["Ver","Agregar","Editar","Eliminar","Exportar","Visible"]
     * @property {number} value - bit de acceso para la columna [0,1]
     * @property {number} userId - id del usuario al que le pertenece el menú
     */
    return ApiExec(params, 'users/update-menu', 'PUT')
      .then((res) => res)
      .then((res) => res)
      .catch((e) => e);
  };

  /**
   * @property {Function} deleteMenu - Función para eliminar un menú del usuario
   * @param {Object} params - Parámetros para el llamado de la api
   * @param {string} token - Token de acceso para el llamado de la api
   * @returns {Object}
   */
  deleteMenu = (params) => {
    /**
     * @typedef {Object} params
     * @property {number} menuId - id del menú a modificar
     * @property {number} userId - id del usuario al que le pertenece el menú
     */
    return ApiExec(params, 'users/delete-menu', 'DELETE')
      .then((res) => res)
      .then((res) => res)
      .catch((e) => e);
  };

  /**
   * @property {Function} insertUserMenu - Función para insertar menus al usuario
   * @param {Object} params - Parámetros para el llamado de la api
   * @param {string} token - Token de acceso para el llamado de la api
   * @returns {Object}
   */
  insertUserMenus = (params) => {
    /**
     * @typedef {Object} params
     * @property {number} menus - menus a insertar, debe ser un arreglo de objetos con estrucura:
     * {
     *   menuId: *valor*,
        see: *valor*,
        create: *valor*,
        edit: *valor*,
        delete: *valor*,
        export: *valor*,
        visible: *valor*
     * }
     * @property {number} userId - id del usuario al que le insertarán los menus
     */
    return ApiExec(params, 'users/insert-menus', 'POST')
      .then((res) => res)
      .then((res) => res)
      .catch((e) => e);
  };

  getMyUsers = (params) => {
    return ApiExec(params, 'users/get-my-users', 'POST')
      .then((res) => res)
      .then((res) => res)
      .catch((e) => e);
  };

  getResponsibles = (params) => {
    return ApiExec(params, 'users/get-responsibles', 'POST')
      .then((res) => res)
      .then((res) => res)
      .catch((error) => error);
  };

  getDataUserOwner = (params) => {
    return ApiExecPublic(params, 'app/users/get-data-user-owner', 'POST')
      .then((res) => res)
      .then((res) => res)
      .catch((error) => error);
  };

  createUser = (params) => {
    return ApiExecPublic(params, 'app/users/public-register-invito', 'POST')
      .then((res) => res)
      .then((res) => res)
      .catch((e) => e);
  };

  codeValidate = (params) => {
    return ApiExecPublic(params, 'app/users/code-validate', 'POST')
      .then((res) => res)
      .then((res) => res)
      .catch((e) => e);
  };

  getAvanceCompromisos = (params) => {
    return ApiExec(params, 'users/get-stats-compromisos', 'POST')
      .then((res) => res)
      .then((res) => res)
      .catch((e) => e);
  };

  messageChange = (params) => {
    return ApiExecPublic(params, 'app/users/recovery-passwd', 'POST')
      .then((res) => res)
      .then((res) => res)
      .catch((e) => e);
  };

  setRecoveryPasswd = (params) => {
    return ApiExecPublic(params, 'app/users/set-recovery-passwd', 'POST')
      .then((res) => res)
      .then((res) => res)
      .catch((e) => e);
  };

  saveSupportRequest = (params) => {
    return ApiExecPublic(params, 'app/support/save-support-request', 'POST')
      .then((res) => res)
      .then((res) => res)
      .catch((e) => e);
  };

  validateRequest = (params) => {
    return ApiExecPublic(params, 'app/support/validate-request', 'POST')
      .then((res) => res)
      .then((res) => res)
      .catch((e) => e);
  };

  deleteDevice = (params) => {
    return ApiExec(params, 'users/delete-device', 'DELETE')
      .then((res) => res)
      .then((res) => res)
      .catch((e) => e);
  };

  getResponsibilities = (id) => {
    const _id = DEBUG ? id : encryptVars(id);
    return ApiExec({}, `users/get-responsibilities/${_id}`, 'GET')
      .then((res) => res)
      .then((res) => res)
      .catch((error) => error);
  };

  getUserSocialLibre = (params) => {
    return ApiExec(params, 'users/get-social-libre')
      .then((res) => res)
      .then((res) => res)
      .catch((e) => e);
  };

  getUserSocial = (params) => {
    return ApiExec(params, 'users/get-social')
      .then((res) => res)
      .then((res) => res)
      .catch((e) => e);
  };

  setMenusByRoles = (params) => ApiExec(params, 'users/set-menus-by-roles');

  deleteMenusByRoles = (params) => ApiExec(params, 'users/delete-menus-by-roles');
}

const user = new UserService();
export default user;
